"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedItemsFractalRowStore = void 0;
var data_structures_1 = require("@tableau/data-structures");
var FractalRowStore_1 = require("./FractalRowStore");
var DestinationItem_1 = require("./DestinationItem");
var Localize_1 = require("../gen-src/Localize");
var NestedItemsFractalRowStore = /** @class */ (function (_super) {
    __extends(NestedItemsFractalRowStore, _super);
    function NestedItemsFractalRowStore(topLevelTrees, rowExpansionHandler, topLevelDestinationStatus, personalSpace) {
        var _a;
        var _this = this;
        var treeWithPersonalSpace;
        var site = NestedItemsFractalRowStore.topLevelItemContainerForProjects(topLevelDestinationStatus);
        var siteItemTree = new data_structures_1.RoseTree(site, topLevelTrees);
        var expandedItemKeys = (_a = {}, _a[NestedItemsFractalRowStore.SentinelRootProjectId] = true, _a);
        if (personalSpace) {
            treeWithPersonalSpace = new data_structures_1.RoseTree(personalSpace, [siteItemTree]);
            _this = _super.call(this, [treeWithPersonalSpace], expandedItemKeys) || this;
        }
        else {
            _this = _super.call(this, [siteItemTree], expandedItemKeys) || this;
        }
        _this.rowExpansionHandler = rowExpansionHandler;
        return _this;
    }
    NestedItemsFractalRowStore.prototype.buildRowFromItem = function (item) {
        var _this = this;
        return {
            key: this.getKey(item),
            parentKey: this.getParentKey(item),
            nestingLevel: item.nestingLevel,
            isExpanded: this.isExpanded(item),
            hasChildren: item.hasChildren,
            expansionHandler: function (isExpanded) { return _this.rowExpansionHandler(item.id, isExpanded); },
            data: item,
        };
    };
    NestedItemsFractalRowStore.prototype.getParentKey = function (item) {
        if (item.id === NestedItemsFractalRowStore.SentinelRootProjectId) {
            return undefined;
        }
        else if (item.isOrphaned) {
            return NestedItemsFractalRowStore.SentinelPermissionsRequiredId;
        }
        else {
            return item.parentId || NestedItemsFractalRowStore.SentinelRootProjectId;
        }
    };
    NestedItemsFractalRowStore.prototype.getKey = function (item) {
        return item.id;
    };
    return NestedItemsFractalRowStore;
}(FractalRowStore_1.FractalRowStore));
exports.NestedItemsFractalRowStore = NestedItemsFractalRowStore;
(function (NestedItemsFractalRowStore) {
    NestedItemsFractalRowStore.SentinelRootProjectId = 'PROJECTS';
    function topLevelItemContainerForProjects(status) {
        return {
            id: NestedItemsFractalRowStore.SentinelRootProjectId,
            itemType: DestinationItem_1.DestinationItemType.projectsRoot,
            name: Localize_1.Messages.ProjectsHeader(),
            nestingLevel: 0,
            hasChildren: true,
            status: status
        };
    }
    NestedItemsFractalRowStore.topLevelItemContainerForProjects = topLevelItemContainerForProjects;
    NestedItemsFractalRowStore.SentinelPermissionsRequiredId = 'PERMISSIONS_REQUIRED';
    function permissionsRequiredProjectContainer() {
        return {
            id: NestedItemsFractalRowStore.SentinelPermissionsRequiredId,
            parentId: undefined,
            name: Localize_1.Messages.permissonsRequiredProjectName(),
            nestingLevel: 1,
            hasChildren: true,
            status: 'structurally_invalid',
            itemType: DestinationItem_1.DestinationItemType.project,
        };
    }
    NestedItemsFractalRowStore.permissionsRequiredProjectContainer = permissionsRequiredProjectContainer;
    function permissionsRequiredItemContainer() {
        return {
            id: NestedItemsFractalRowStore.SentinelPermissionsRequiredId,
            parentId: undefined,
            name: Localize_1.Messages.permissonsRequiredProjectName(),
            nestingLevel: 1,
            hasChildren: true,
            status: 'structurally_invalid',
            itemType: DestinationItem_1.DestinationItemType.project
        };
    }
    NestedItemsFractalRowStore.permissionsRequiredItemContainer = permissionsRequiredItemContainer;
})(NestedItemsFractalRowStore = exports.NestedItemsFractalRowStore || (exports.NestedItemsFractalRowStore = {}));
exports.NestedItemsFractalRowStore = NestedItemsFractalRowStore;
//# sourceMappingURL=NestedItemsFractalRowStore.js.map